import { Pagination as PaginationBase, PaginationProps } from 'antd';

export const Pagination: React.FC<PaginationProps> = ({
  className,
  ...props
}) => {
  return <PaginationBase className={className} {...props} />;
};
